module.exports = __webpack_public_path__ + "static/media/Meadows-at-Northville-Ridge.fa408d59.pdf";